import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # Incident
 *
 * Incident을 설명하세요.
 */
export const Incident = types
  .model('Incident')
  // --------------------------------------------------------------------------
  .props({
    incidentSid: types.identifierNumber,
    incidentDt: types.maybeNull(types.number), // 일자
    incidentTarget: types.maybeNull(types.string), // 대상
    incidentContent: types.maybeNull(types.string), // 내용

    useYn: types.optional(types.string, 'Y'),
    delYn: types.optional(types.string, 'N'),

    insertDt: types.optional(types.number, 0),
    updateDt: types.optional(types.number, 0),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model incident --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IIncident;
      (Object.keys(newProps) as TIncidentKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TIncident = Instance<typeof Incident>;
type TIncidentSnapshot = SnapshotOut<typeof Incident>;

export interface IIncident extends TIncident {}
export type TIncidentKeys = keyof TIncidentSnapshot & string;
export interface IIncidentSnapshot extends TIncidentSnapshot {}
export const createIncident = () => types.optional(Incident, {} as TIncident);
